<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <b-row>
            <b-col cols="4">
              <vs-card>
                <b-form-group label="Sipariş Durumu" label-for="item-name">
                  <v-select
                    v-model="secilenDurum"
                    :options="durumlist"
                    label="name"
                    style=""
                    @input="siparisCek(0)"
                  >
                  </v-select>
                </b-form-group>
              </vs-card>
            </b-col>
          </b-row>
          <div class="demo-alignment">
            <vs-button
              style="border-radius: 5px"
              type="gradient"
              color="success"
              id="button-with-loading-yeni"
              class="vs-con-loading__container"
              @click="siparisCek(0)"
              >Sipariş Çek</vs-button
            ><vs-button
              style="border-radius: 5px"
              type="gradient"
              @click="siparisListesi()"
              >Sipariş Listele</vs-button
            ><vs-button
              style="border-radius: 5px"
              type="gradient"
              color="danger"
              ref="loadableButton"
              id="button-with-loading-control"
              class="vs-con-loading__container"
              @click="siparisKontrol()"
              >Sipariş Kontrol</vs-button
            >
            <vs-button
              style="border-radius: 5px"
              type="gradient"
              color="#fc9551"
              gradient-color-secondary="rgb(255, 115, 0)"
              id="button-with-loading"
              ref="loadableButton"
              class="vs-con-loading__container"
              @click="siparisKaydet()"
              :disabled="islemTipi === '0'"
              >Sipariş Kaydet</vs-button
            >
            <vs-button
              style="border-radius: 5px"
              type="gradient"
              color="#bc49c4"
              gradient-color-secondary="rgb(110, 4, 138)"
              id="button-with-loading-partile"
              class="vs-con-loading__container"
              @click="activePrompt = true"
              >Partile</vs-button
            >
            <vs-button
              style="border-radius: 5px"
              type="gradient"
              color="#ea5455"
              gradient-color-secondary="rgb(97, 1, 2)"
              ref="loadableButton"
              id="button-with-loading-toplu"
              class="vs-con-loading__container"
              @click="topluFaturaKayit()"
              >Fatura Kayıt</vs-button
            >

            <!-- <vs-button @click="kalanSiparisListesi()" color="blue" type="filled">Açıkta Kalan Siparişler</vs-button>
            <vs-button @click="iadeCek(0)" color="green" id="button-with-loading-yeni-iade" class="vs-con-loading__container" type="filled">İadeleri Çek</vs-button>-->
            <!-- <vs-button
              style="border-radius: 5px"
              type="gradient"
              color="#4ab802"
              gradient-color-secondary="rgb(1, 82, 16)"
              id="button-with-loading-TopluKaydet"
              class="vs-con-loading__container"
              @click="siparisYaz()"
              >Toplu Kaydet</vs-button
            > -->
            <vs-button
              style="border-radius: 5px"
              type="gradient"
              color="#02a66d"
              gradient-color-secondary="rgb(1, 52, 74)"
              @click="tamamlananSiparis()"
              >Tamamlanan Siparişler</vs-button
            ><!--
            <HepsiLojistikComponent
              :program="pazaryer"
              ref="secilenSiparisler"
            />-->
            <SiparisExcel
              :excelData="pazaryeriSiparisKalemList"
              :pazaryer="pazaryer"
              :title="'Pazaryeri Sipariş Kalem'"
            />
            <vs-progress
              :percent="progress"
              v-model="progress"
              color="primary"
            ></vs-progress>
          </div>
        </vx-card>
        <vx-card title=""> </vx-card>
      </div>

      <div
        class="vx-col lg:w-4/4 w-full relative"
        :hidden="tamamlananValidated"
      >
        <vx-card title="">
          <b-row>
            <b-col cols="12" style="padding: 0; padding-right: 20px">
              <b-row align-h="start">
                <b-col cols="12" md="auto"
                  ><vs-input
                    class="inputx"
                    placeholder="Arama..."
                    @keyup.enter="tamamlananSiparis()"
                    :ref="aranan"
                    v-model="aranan"
                  />
                </b-col>
                <b-col cols="12" md="auto">
                  <SiparisExcel
                    :excelData="tamamlananList"
                    :pazaryer="pazaryer"
                    :title="'Excel'"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </vx-card>
        <vs-table stripe :data="tamamlananList">
          <template slot="thead">
            <vs-th sort-key="orderNumber">Sipariş No</vs-th>
            <vs-th sort-key="invoiceFirstName">Adı Soyadı</vs-th>
            <vs-th sort-key="cargoTrackingNumber">Kargo No</vs-th>
            <vs-th sort-key="grossAmount">Tutar</vs-th>
            <vs-th sort-key="siparisAdetleri">Parca Adedi</vs-th>
            <vs-th sort-key="shipFullName">Teslimat Adı</vs-th>
            <vs-th sort-key="stokkodu">Sipariş Tarihi</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].orderNumber">
                {{ data[indextr].orderNumber }}
              </vs-td>
              <vs-td :data="data[indextr].invoiceFirstName">
                {{ data[indextr].invoiceFirstName }}
                {{ data[indextr].invoiceLastName }}
              </vs-td>
              <vs-td :data="data[indextr].cargoTrackingNumber">
                {{ data[indextr].cargoTrackingNumber }}
              </vs-td>

              <vs-td :data="data[indextr].grossAmount">
                {{ data[indextr].grossAmount }}
              </vs-td>

              <vs-td :data="data[indextr].siparisAdetleri">
                {{ data[indextr].siparisAdetleri }}
              </vs-td>

              <vs-td :data="data[indextr].shipFullName">
                {{ data[indextr].shipFullName }}
              </vs-td>
              <vs-td :data="data[indextr].siparisTarihi">
                {{ data[indextr].siparisTarihi }}
              </vs-td>
              <vs-td>
                <vs-button
                  @click="siparisDetay(data[indextr].orderNumber)"
                  icon-pack="feather"
                  icon="icon-search"
                  color="primary"
                  type="filled"
                ></vs-button>
              </vs-td>
            </vs-tr>
            <vs-td colspan="4" style="text-align: right">Toplam : </vs-td>
            <vs-td>{{ toplamParca }} Parça</vs-td>
            <vs-tr> </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="vx-col lg:w-4/4 w-full relative">
        <!--
        <ag-grid-vue
          style="width: 100%; height: 400px; margin-top: 25px"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefs"
          :rowData="list"
          :localeText="localeText"
          @grid-ready="onGridReady"
          @first-data-rendered="onFirstDataRendered"
          @selection-changed="onSelectionChanged"
          :rowSelection="rowSelection"
          :suppressRowClickSelection="true"
        >
        </ag-grid-vue>
      -->
        <vs-table :data="list" :hidden="validated">
          <template slot="thead">
            <vs-th sort-key="stokkodu">Sipariş No</vs-th>
            <vs-th>Adı Soyadı</vs-th>
            <vs-th>Kargo No</vs-th>
            <vs-th>Tutar</vs-th>
            <vs-th>Parca Adedi</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].orderNumber">
                {{ data[indextr].orderNumber }}
              </vs-td>
              <vs-td :data="data[indextr].invoiceFirstName">
                {{ data[indextr].invoiceFirstName }}
                {{ data[indextr].invoiceLastName }}
              </vs-td>
              <vs-td :data="data[indextr].cargoTrackingNumber">
                {{ data[indextr].cargoTrackingNumber }}
              </vs-td>

              <vs-td :data="data[indextr].grossAmount">
                {{ data[indextr].grossAmount }}
              </vs-td>

              <vs-td :data="data[indextr].siparisAdetleri">
                {{ data[indextr].siparisAdetleri }}
              </vs-td>
            </vs-tr>
            <vs-td colspan="4" style="text-align: right">Toplam : </vs-td>
            <vs-td>{{ toplamParca }} Parça</vs-td>
            <vs-tr> </vs-tr>
          </template>
        </vs-table>
        <vs-table :data="listEksik" :hidden="validated1">
          <template slot="thead">
            <vs-th sort-key="orderNumber">Sipariş No</vs-th>
            <vs-th sort-key="partiNo">Parti No</vs-th>
            <vs-th sort-key="musteriAdi">Adı Soyadı</vs-th>
            <vs-th sort-key="merchantSku">Ürün Kodu</vs-th>
            <vs-th sort-key="productName">Ürün Adı</vs-th>
            <vs-th sort-key="quantity">Adet</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].orderNumber">
                {{ data[indextr].orderNumber }}
              </vs-td>
              <vs-td :data="data[indextr].partiNo">
                {{ data[indextr].partiNo }}
              </vs-td>
              <vs-td :data="data[indextr].musteriAdi">
                {{ data[indextr].musteriAdi }}
              </vs-td>
              <vs-td :data="data[indextr].merchantSku">
                {{ data[indextr].merchantSku }}
              </vs-td>

              <vs-td :data="data[indextr].productName">
                {{ data[indextr].productName }}
              </vs-td>

              <vs-td :data="data[indextr].quantity">
                {{ data[indextr].quantity }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div class="con-pagination-table vs-table--pagination">
          <div
            class="vs-row"
            style="justify-content: space-between; display: flex; width: 100%"
          >
            <div
              class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6"
              style="
                justify-content: flex-start;
                display: flex;
                align-items: center;
                margin-left: 0%;
                width: 100%;
              "
            ></div>
            <div
              class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6"
              style="
                justify-content: flex-end;
                display: flex;
                align-items: center;
                margin-left: 0%;
                width: 100%;
              "
            >
              <div class="con-vs-pagination vs-pagination-primary">
                <nav class="vs-pagination--nav">
                  <button
                    class="
                      vs-pagination--buttons
                      btn-prev-pagination
                      vs-pagination--button-prev
                    "
                    @click="sayfaGeri()"
                  >
                    <i
                      class="vs-icon notranslate icon-scale material-icons null"
                      >chevron_left</i
                    >
                  </button>
                  <ul class="vs-pagination--ul"></ul>
                  <button
                    class="
                      vs-pagination--buttons
                      btn-next-pagination
                      vs-pagination--button-next
                    "
                    @click="sayfaIleri()"
                  >
                    <i
                      class="vs-icon notranslate icon-scale material-icons null"
                      >chevron_right</i
                    >
                  </button>
                  <!---->
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vs-prompt
      title="Partileme İşlemleri"
      acceptText="İşlemi Başlat"
      cancelText="Vazgeç"
      @accept="partilemeyiBaslat"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt">
        <span>Partileme Miktarı</span>
        <vs-input
          type="number"
          placeholder="Sayı Giriniz"
          vs-placeholder="Code"
          v-model="partiVal"
          class="mt-3 w-full"
        />
        <div v-if="faturaorandegerKontrolVal == true">
          <span>Fatura Oran</span>
          <vs-input
            type="number"
            placeholder="Oran Giriniz"
            vs-placeholder="Oran"
            v-model="oranVal"
            class="mt-3 w-full"
          />
        </div>
      </div>
    </vs-prompt>
    <SiparisDetayButton ref="siparisCek" />
  </div>
</template>
<script>
import state from "../../store/state";
import Store from "../../store/store";
import vSelect from "vue-select";
import SiparisDetayButton from "../components/uzum-components/pazaryeri-components/SiparisDetayButton.vue";
import SiparisExcel from "../components/uzum-components/pazaryeri-components/SiparisExcel.vue";
import HepsiLojistikComponent from "../components/uzum-components/pazaryeri-components/HepsiLojistikComponent.vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
export default {
  data() {
    return {
      rowSelection: null,
      localeText: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      columnDefs: null,
      secilenSiparisler: [],
      secilenDurum: "",
      durumlist: [
        { name: "Oluşturuldu", val: "Created" },
        { name: "Onaylandı", val: "Picking" },
        { name: "Faturalandı", val: "Invoiced" },
        { name: "Kargolandı", val: "Shipped" },
        { name: "İptal Edildi", val: "Cancelled" },
        { name: "Teslim Edildi", val: "Delivered" },
        { name: "Teslim Edilemedi", val: "UnDelivered" },
        { name: "Geri Gönderildi", val: "Returned" },
        { name: "Tekrar Paketlendi", val: "Repack" },
        { name: "Tedarik Edilemedi", val: "UnSupplied" }
      ],
      pazaryer: "Boyner",
      faturaorandegerKontrolVal: false,
      aranan: "",
      list: [],
      listEksik: [],
      tamamlananList: [],
      tamamlananValidated: true,
      pazaryeriSiparisKalemList: [],

      progress: 0,
      sayfaListe: 0,
      toplamSayfa: 0,
      activePrompt: false,
      partiVal: "",
      oranVal: "",
      toplamParca: 0,
      backgroundLoading: "danger",
      colorLoading: "#fff",
      siparisKaydetSayi: 0,
      validated: true,
      validated1: true,
      siparisKontrolBasildimi: 0,
      islemTipi: Store.state.islemTipi,
      topluFaturaSayfa: 0
    };
  },
  //siparisKalemRapor token pazaryeri
  components: {
    AgGridVue,
    "v-select": vSelect,
    SiparisExcel,
    SiparisDetayButton,
    HepsiLojistikComponent
  },
  created() {
    this.rowSelection = "multiple";
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.faturaOranDegerKontrol();
    this.pazaryeriSiparisKalem();
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      this.secilenSiparisler = selectedRows;
      this.$refs.secilenSiparisler.sepetSecilen(selectedRows);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    pazaryeriSiparisKalem() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        program: "Boyner"
      };

      soap.createClient(url, function(err, client) {
        client.siparisKalemRapor(args, function(err, result) {
          if (result.siparisKalemRaporResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.siparisKalemRaporResult);
          vm.pazaryeriSiparisKalemList = vm.veriler;
          //  console.log(vm.veriler);
        });
      });
    },
    faturaOranDegerKontrol() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.FaturaOranliCalisma(args, function(err, result) {
          if (result.FaturaOranliCalismaResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.FaturaOranliCalismaResult);

          vm.faturaorandegerKontrolVal = vm.veriler;
        });
      });
    },
    siparisDetay(orderNumber) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: "Boyner",
        orderNumber: orderNumber
      };

      soap.createClient(url, function(err, client) {
        client.pazaryeriTamamlananSiparisCek(args, function(err, result) {
          if (result.pazaryeriTamamlananSiparisCekResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.pazaryeriTamamlananSiparisCekResult);
          vm.$refs.siparisCek.siparisDetayCek(vm.veriler);

          if (vm.veriler.response == "Ok") {
            // alert("ok")
          } else {
            //alert("Veriler Çekilemedi");
          }
        });
      });
    },

    tamamlananSiparis() {
      this.tamamlananValidated = false;
      this.validated = true;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: "Boyner",
        orderNumber: this.aranan
      };
      soap.createClient(url, function(err, client) {
        client.pazaryeriTamamlananSiparisCek(args, function(err, result) {
          if (result.pazaryeriTamamlananSiparisCekResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.pazaryeriTamamlananSiparisCekResult);
          // vm.toplamSayfa = vm.veriler[0]["toplamKayitSayisi"];
          vm.tamamlananList = vm.veriler;
        });
      });
    },

    siparisCek(sayfasayisi) {
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: this.colorLoading,
        container: "#button-with-loading-yeni",
        scale: 0.45
      });

      var vm = this;
      let args = {};

      var secilenDurumDegeri = vm.secilenDurum.val;
      if (
        secilenDurumDegeri == "" ||
        typeof secilenDurumDegeri == "undefined"
      ) {
        args = {
          pazaryeri: "Boyner",
          siparisDurumu: 0,
          listelenecekSayfa: sayfasayisi,
          token: Store.state.tokenId
        };
      } else {
        {
          args = {
            pazaryeri: "Boyner",
            siparisDurumu: 0,
            listelenecekSayfa: sayfasayisi,
            token: Store.state.tokenId,
            islemDurumu: secilenDurumDegeri
          };
        }
      }
      console.log(args);
      const soap = require("soap");
      const url = state.sistemAddress;

      soap.createClient(url, function(err, client) {
        client.pazaryeriSiparisCek(args, function(err, result) {
          if (result.pazaryeriSiparisCekResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.pazaryeriSiparisCekResult);
            if (vm.veriler.response == "Ok") {
              if (parseInt(vm.veriler.page) < parseInt(vm.veriler.totalPages)) {
                vm.veriler.page = parseInt(vm.veriler.page) + 1;
                const percent = 100 / parseInt(vm.veriler.totalPages);
                vm.progress = percent * vm.veriler.page;
                vm.siparisCek(vm.veriler.page);
              } else {
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
                vs.notify({
                  title: "Boyner",
                  text: "Siparişler Çekildi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              }
            } else {
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              vs.notify({
                title: "Boyner",
                text: "Siparişler Çekildi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            vs.notify({
              title: "Boyner",
              text: vm.veriler.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    siparisYaz() {
      var vm = this;
      var vs = this.$vs;

      vs.loading({
        background: "#015210",
        color: this.colorLoading,
        container: "#button-with-loading-TopluKaydet",
        scale: 0.45
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { program: "Boyner", token: Store.state.tokenId };

      soap.createClient(url, function(err, client) {
        client.siparisYazToplu(args, function(err, result) {
          if (result.siparisYazTopluResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.siparisYazTopluResult);

            if (vm.veriler.response == "Ok") {
              vs.loading.close(
                "#button-with-loading-TopluKaydet > .con-vs-loading"
              );
              vs.notify({
                title: "Toplu Sipariş",
                text: "Toplu Siparişler Yazılı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            } else {
              vs.notify({
                title: "Toplu Sipariş",
                text: "Toplu Siparişler Yazılamadı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          } catch (error) {
            console.log(result);
            vs.loading.close(
              "#button-with-loading-TopluKaydet > .con-vs-loading"
            );
            vs.notify({
              title: "Toplu Sipariş",
              text: "Toplu Siparişler Yazılamadı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    iadeCek(sayfasayisi) {
      var vs = this.$vs;
      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-yeni-iade",
        scale: 0.45
      });

      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: "Boyner",
        listelenecekSayfa: sayfasayisi,
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.iadeSiparisCek(args, function(err, result) {
          if (result.iadeSiparisCekResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.iadeSiparisCekResult);
          if (vm.veriler.response == "Ok") {
            if (parseInt(vm.veriler.page) < parseInt(vm.veriler.totalPages)) {
              vm.veriler.page = parseInt(vm.veriler.page) + 1;
              const percent = 100 / parseInt(vm.veriler.totalPages);
              vm.progress = percent * vm.veriler.page;
              vm.iadeSiparisCek(vm.veriler.page);
            } else {
              vs.loading.close(
                "#button-with-loading-yeni-iade > .con-vs-loading"
              );
              vs.notify({
                title: "Boyner",
                text: "İadeler Çekildi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            }
          } else {
            alert("Veriler Çekilemedi");
          }
        });
      });
    },
    sayfaIleri() {
      this.sayfaListe = this.sayfaListe + 1;
      if (this.sayfaListe > this.toplamSayfa) {
        this.sayfaListe = this.toplamSayfa;
      }
      this.siparisListesi();
    },
    sayfaGeri() {
      this.sayfaListe = this.sayfaListe - 1;
      if (this.sayfaListe < 0) {
        this.sayfaListe = 0;
      }
      this.siparisListesi();
    },
    siparisListesi() {
      this.tamamlananValidated = true;
      this.validated1 = true;
      this.validated = false;
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: "Boyner",
        token: Store.state.tokenId,
        sayfa: vm.sayfaListe
      };
      soap.createClient(url, function(err, client) {
        client.siparisListele(args, function(err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            console.log(result);

            vm.veriler = JSON.parse(result.siparisListeleResult);
            vm.toplamSayfa = vm.veriler[0]["toplamKayitSayisi"];
            vm.list = vm.veriler;
          } catch (error) {
            vs.notify({
              title: "Boyner",
              text: "Siparişler listelenirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    kalanSiparisListesi() {
      this.validated1 = false;
      this.validated = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { pazaryeri: "Boyner", token: Store.state.tokenId };
      soap.createClient(url, function(err, client) {
        client.kalanSiparisListesi(args, function(err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.kalanSiparisListesiResult);
          vm.listEksik = vm.veriler;
        });
      });
    },
    partilemeyiBaslat() {
      const vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (this.partiVal != null || this.partiVal != "") {
        const args = {
          pazaryeri: "Boyner",
          parti: this.partiVal,
          token: Store.state.tokenId,
          faturaOran: this.oranVal
        };

        vs.loading({
          background: "#6e048a",
          color: this.colorLoading,
          container: "#button-with-loading-partile",
          scale: 0.45
        });

        console.log(args);
        soap.createClient(url, function(err, client) {
          client.partile(args, function(err, result) {
            if (result.partileResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }

            try {
              vm.veriler = JSON.parse(result.partileResult);
              if (vm.veriler.response == "Ok") {
                vs.loading.close(
                  "#button-with-loading-partile > .con-vs-loading"
                );
                vs.notify({
                  title: "Partileme",
                  text: "Partileme İşlemi Başarılı",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              } else {
                vs.notify({
                  title: "Partileme",
                  text: "Partilemede Hata Oluştu",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
              }
            } catch (error) {
              console.log(result);
              vs.loading.close(
                "#button-with-loading-partile > .con-vs-loading"
              );
              vs.notify({
                title: "Partileme",
                text: "Partilemede Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      } else {
        const args1 = {
          pazaryeri: "Boyner",
          parti: this.partiVal,
          token: Store.state.tokenId
        };

        vs.loading({
          background: "#6e048a",
          color: this.colorLoading,
          container: "#button-with-loading-partile",
          scale: 0.45
        });
        console.log(args1);
        soap.createClient(url, function(err, client) {
          client.partile(args1, function(err, result) {
            if (result.partileResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }

            try {
              vm.veriler = JSON.parse(result.partileResult);
              if (vm.veriler.response == "Ok") {
                vs.loading.close(
                  "#button-with-loading-partile > .con-vs-loading"
                );
                vs.notify({
                  title: "Partileme",
                  text: "Partileme İşlemi Başarılı",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              } else {
                vs.notify({
                  title: "Partileme",
                  text: "Partilemede Hata Oluştu",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
              }
            } catch (error) {
              console.log(result);
              vs.loading.close(
                "#button-with-loading-partile > .con-vs-loading"
              );
              vs.notify({
                title: "Partileme",
                text: "Partilemede Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    siparisKaydet() {
      var vs = this.$vs;
      if (this.siparisKontrolBasildimi == 1) {
        vs.loading({
          background: "#ff7300",
          color: this.colorLoading,
          container: "#button-with-loading",
          scale: 0.45
        });

        var vm = this;

        const soap = require("soap");
        const url = state.sistemAddress;
        const args = {
          program: "Boyner",
          sayfa: this.siparisKaydetSayi,
          token: Store.state.tokenId,
          EMPLOYEEID: Store.state.plasiyer
        };
        soap.createClient(url, function(err, client) {
          client.siparisKaydet(args, function(err, result) {
            if (result.siparisKaydetResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }

            try {
              console.log(
                "result.siparisKaydetResult:" + result.siparisKaydetResult
              );
              vm.veriler = JSON.parse(result.siparisKaydetResult);
              //console.log(vm.veriler)
              
              if (vm.veriler.response == "Bitti" || vm.veriler.response == "Ok") {
                vs.loading.close("#button-with-loading > .con-vs-loading");
                vm.siparisKontrol();
              }
            } catch (error) {
              console.log(result);
              vs.loading.close("#button-with-loading > .con-vs-loading");

              vs.notify({
                title: "Sipariş Kaydet",
                text: "Sipariş Kaydederken Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      } else {
        vs.notify({
          title: "Sipariş Kayıt",
          text: "Siparişi Kaydetmeden Önce Sipariş Kontrol Butonuna Basınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      }
    },
    topluFaturaKayit() {
      var vs = this.$vs;

      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-toplu",
        scale: 0.45
      });

      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: "Boyner",
        sayfa: 0,
        token: Store.state.tokenId,
        EMPLOYEEID: this.topluFaturaSayfa
      };
      soap.createClient(url, function(err, client) {
        client.topluFaturaKaydet(args, function(err, result) {
          vm.veriler = JSON.parse(result.topluFaturaKaydetResult);
          try {
            //console.log(vm.veriler)
            //console.log(vm.veriler)
            if (vm.veriler.response == "Ok") {
              // console.log("burda 5 ");
              vm.siparisKaydetSayi = vm.siparisKaydetSayi + 100;
              if (vm.topluFaturaSayfa <= vm.siparisKaydetSayi) {
                // console.log("burda 6 ");
                vs.loading.close(
                  "#button-with-loading-toplu > .con-vs-loading"
                );
              } else {
                //console.log("burda 7 ");
                //console.log(vm.topluFaturaSayfa+" --- "+vm.siparisKaydetSayi)
                vm.topluFaturaKayit();
              }
            } else {
              if (vm.topluFaturaSayfa == 0) {
                //console.log(vm.veriler+"dddd")
                //console.log("burda 1 ");
                //console.log(vm.veriler)
                if (parseInt(vm.veriler) > 0) {
                  // console.log("burda 2 ");
                  // console.log(2)
                  vm.topluFaturaSayfa = parseInt(vm.veriler);
                  vm.topluFaturaKayit();
                } else {
                  console.log("burda 3 ");
                  vs.loading.close(
                    "#button-with-loading-toplu > .con-vs-loading"
                  );
                }
              } else {
                // console.log("burda 4 ");
                vm.topluFaturaKayit();
              }
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-toplu > .con-vs-loading");
            vs.notify({
              title: "Toplu Fatura Kayıt",
              text:
                "Toplu Fatura Kayıt Sırasında Hata Oluştu" + vm.veriler.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center"
            });
          }
        });
      });
    },
    siparisKontrol() {
      this.siparisKontrolBasildimi = 1;
      this.validated1 = true;
      this.validated = false;
      const vm = this;
      var vs = this.$vs;
      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-control",
        scale: 0.45
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { program: "Boyner", token: Store.state.tokenId };
      soap.createClient(url, function(err, client) {
        client.siparisKontrol(args, function(err, result) {
          if (result.siparisKontrolResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.siparisKontrolResult);
            vm.list = vm.veriler;

            vs.loading.close("#button-with-loading-control > .con-vs-loading");
            vs.notify({
              title: "Boyner",
              text: "Siparişler Kontrol Edildi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
          } catch (error) {
            console.log(result);

            vs.loading.close("#button-with-loading-control > .con-vs-loading");

            vs.notify({
              title: "Boyner",
              text: "Siparişler Kontrol Edilirken Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    }
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("boynerSiparisList", () => {
      this.siparisListesi();
    });
  },
  beforeDestroy() {
    this.$root.$off("boynerSiparisList");
  },
  watch: {
    list: {
      handler: function() {
        //this.toplamParca=this.list.reduce((acc, item) => Number(acc) + (Number(item.siparisAdetleri)), 0)
        this.toplamParca = this.list.reduce(
          (sum, item) => sum + item.siparisAdetleri,
          0
        );
      },
      deep: true
    }
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        showDisabledCheckboxes: true,
        width: 50
      },
      {
        headerName: "Sipariş Numarası",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Müşteri Ad Soyad",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "invoiceFirstName",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kargo No",
        field: "cargoTrackingNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tutar",
        field: "grossAmount",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Sipariş Adetleri",
        field: "siparisAdetleri",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
  }
};
</script>
<style lang="scss" scoped>
.mb-base {
  margin-bottom: 0.75rem !important;
}
.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
